import { Divider } from 'antd';
import { useUser } from 'hooks';
import moment from 'moment';
import { useRouter } from 'next/router';
import React from 'react';
import { IoPeopleSharp, IoPersonRemove } from 'react-icons/io5';
import { IoPersonAdd } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { getOnBoardDateFilter } from 'store/global';

const TotalOnboard = ({ count }) => {
  const router = useRouter();
  const user = useUser();
  const onBoardDate = useSelector(getOnBoardDateFilter);
  
  const handleDatefilter = () => {
    const formattedRange = onBoardDate
      .map((date) => moment(date).format('DD/MM/YYYY'))
      .join(' - ');

    return onBoardDate.length === 1
      ? `${formattedRange} - ${formattedRange}`
      : formattedRange;
  };

  return (
    <>
      <div className="total-onboading-card ">
        {/* <div className="total-onboarding-count-ui">
          <h6 className="onboard-enroll-counts m-0">{count?.totalCount}</h6>
          <p className="lesson-label-tittle m-0">Total Staff</p>
        </div> */}
        <div className="total-onboarding-count-ui-box">
          <section
            className="d-flex justify-content-center align-items-center w-100"
            style={{ gap: '15px', cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? `/manage-staff-request?requestTypes=ON_BOARDING&statusId=COMPLETED&createdAt=${handleDatefilter()}~Between`
                  : `/staff-request?requestTypes=ON_BOARDING&statusId=COMPLETED&createdAt=${handleDatefilter()}~Between`,
              )
            }
          >
            <div className="onboard-user-circle">
              <IoPersonAdd color="#0DA678" size={25} />
            </div>
            <div>
              <p className="lesson-label-tittle m-0">Onboarded</p>
              <h6 className="onboard-enroll-counts m-0">
                {count?.onBoardingCount}
              </h6>
            </div>
          </section>
          {/* <section className="d-flex justify-content-between align-items-center w-100">
          <Divider
            style={{
              width: '10%',
              minWidth: '10%',
              border: '1px solid #F8E3BF',
            }}
          />
          <div
            className="onboard-count-card"
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? `/manage-staff-request`
                  : `/staff-request`,
              )
            }
            style={{ cursor: 'pointer' }}
          >
            <h6 className="onboard-staff-counts m-0">{count?.totalCount}</h6>
            <p className="lesson-label-tittle m-0">Total Staff</p>
          </div>
          <Divider
            style={{
              width: '10%',
              minWidth: '10%',
              border: '1px solid #F8E3BF',
            }}
          />
        </section> */}
          <section
            className="d-flex justify-content-center align-items-center w-100"
            style={{ gap: '15px', cursor: 'pointer' }}
            // onClick={() =>
            //   router.push(
            //     user?.type.name === 'HR'
            //       ? `/manage-staff-request?requestTypes=OFF_BOARDING&statusId=COMPLETED`
            //       : `/staff-request?requestTypes=OFF_BOARDING&statusId=COMPLETED`,
            //   )
            // }
          >
            <div className="onboard-user-circle">
              <IoPeopleSharp color="#347FF1" size={25} />
            </div>
            <div>
              <p className="lesson-label-tittle cursor-default m-0">
                {count?.transferCount <= 1 ? 'Active User' : 'Active Users'}
              </p>
              <h6 className="onboard-enroll-counts m-0">
                {count?.transferCount}
              </h6>
            </div>
          </section>
          <section
            className="d-flex justify-content-center align-items-center w-100"
            style={{ gap: '15px', cursor: 'pointer' }}
            onClick={() =>
              router.push(
                user?.type.name === 'HR'
                  ? `/manage-staff-request?requestTypes=OFF_BOARDING&statusId=COMPLETED&createdAt=${handleDatefilter()}~Between`
                  : `/staff-request?requestTypes=OFF_BOARDING&statusId=COMPLETED&createdAt=${handleDatefilter()}~Between`,
              )
            }
          >
            <div className="onboard-user-circle">
              <IoPersonRemove color="#CC171D" size={25} />
            </div>
            <div>
              <p className="lesson-label-tittle m-0">Offboarded</p>
              <h6 className="onboard-enroll-counts m-0">
                {count?.offBoardingCount}
              </h6>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default TotalOnboard;
